<i *ngIf="displayIcon && !loading" class="icnFileVideo jmVideo" (click)="displayVideo()" ngbTooltip="{{toolTip}}" container="body" placement="{{tipPos}}"></i>
<span *ngIf="loading" class="jmWidgetLoadingIcon20" style="vertical-align:text-top; top:5px; position:relative;"></span>
